module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "nuggetForm",
    attrs: {
      "label-position": "top",
      "label-width": "150px",
      "model": _vm.localNugget,
      "rules": _vm.rules
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": ("" + (_vm.localNugget.title)),
      "prop": "value"
    }
  }, [(_vm.localNugget.field === 'gender') ? [_c('el-select', {
    attrs: {
      "placeholder": "Select Gender"
    },
    model: {
      value: (_vm.localNugget.value),
      callback: function($$v) {
        _vm.$set(_vm.localNugget, "value", $$v)
      },
      expression: "localNugget.value"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Male",
      "value": "Male"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Female",
      "value": "Female"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Other",
      "value": "Other"
    }
  })], 1)] : (_vm.localNugget.field === 'age_range') ? [_c('el-select', {
    attrs: {
      "placeholder": "Select Age"
    },
    model: {
      value: (_vm.localNugget.value),
      callback: function($$v) {
        _vm.$set(_vm.localNugget, "value", $$v)
      },
      expression: "localNugget.value"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Under 18",
      "value": "Under 18"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "18-24",
      "value": "18-24"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "25-34",
      "value": "25-34"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "35-49",
      "value": "35-49"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "50-64",
      "value": "50-64"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "65+",
      "value": "65+"
    }
  })], 1)] : [_c('el-input', {
    attrs: {
      "placeholder": ("Enter new " + (_vm.localNugget.title))
    },
    model: {
      value: (_vm.localNugget.value),
      callback: function($$v) {
        _vm.$set(_vm.localNugget, "value", $$v)
      },
      expression: "localNugget.value"
    }
  })]], 2)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer clearfix",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    staticClass: "ibox-tool-btn",
    attrs: {
      "type": "danger",
      "size": "small",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    staticClass: "ibox-tool-btn",
    attrs: {
      "type": "primary",
      "size": "small",
      "loading": _vm.savingNugget,
      "disabled": !_vm.isValueChanged || _vm.savingNugget,
      "plain": ""
    },
    on: {
      "click": _vm.handleEditFormSave
    }
  }, [_vm._v("Save")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d119b20","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/permission/profile/dialogs/EditNuggetDialog.vue
// module id = 3298
// module chunks = 3